import { Icon } from "@/components/Icon/Icon";
import type { SignInEmailError } from "../useSignInFlow";

type Props = {
  email: string;
  onChange: (v: string) => void;
  error: SignInEmailError;
};

export function EmailField({ email, onChange, error }: Props) {
  const isNoAccount = error === "noaccount";
  const isOtherError = error !== "none" && error !== "noaccount";

  return (
    <div className="signin-field">
      <label className="signin-field-label" htmlFor="signin-email">
        Email
      </label>
      <input
        id="signin-email"
        className={`signin-field-input${isNoAccount ? " signin-field-input--error" : ""}`}
        type="email"
        autoComplete="email"
        placeholder="you@company.com"
        value={email}
        onChange={(e) => onChange(e.target.value)}
        required
      />
      {isNoAccount && (
        <div className="signin-noaccount">
          <Icon name="alert" size={13} />
          <span>
            We couldn't find an account for{" "}
            <span className="signin-noaccount-email">{email}</span>. Check the
            spelling, try a different email, or <a href="#">contact sales</a>.
          </span>
        </div>
      )}
      {isOtherError && <div className="signin-error">{error}</div>}
    </div>
  );
}
